'use es6';

import { CommonTriggerDataAttributes } from "../../utils/popupStateMapping.js";

/**
 * Present when the corresponding tooltip is open.
 */
export const popupOpen = CommonTriggerDataAttributes.popupOpen;
/**
 * Present when the trigger is disabled, either by the `disabled` prop or by a parent `<Tooltip.Root>` component.
 */
export const triggerDisabled = 'data-trigger-disabled';